import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "./LanguageContext";

const CookieConsentOverlay = ({ onAccept }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useContext(LanguageContext);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleAccept = () => {
    setIsVisible(false);
    onAccept();
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-overlay">
      <div className="cookie-container">
        <p className="cookie-text">{t("cookieConsentText")}</p>
        <p className="cookie-details">{t("cookieConsentDetails")}</p>
        <div className="cookie-buttons">
          <button
            className="cookie-button accept-button"
            onClick={handleAccept}
            style={{ backgroundColor: "#4f9fca", width: "100%" }}
          >
            {t("accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentOverlay;
